import React from "react";
import { makeObservable, observable, computed, reaction } from "mobx";

import * as Components from "./components";

export class AppStore {

  ready = false;
  complete = false;
  enterprise = {
    id: "0000",
    name: "Sandbox"
  };
  identity = null;
  currentView = "EmailPasswordLogin";
  nextView = null;
  viewData = {};
  context = {};
  team = {};
  reviewerSettings = {};

  get anonSettings() { return window.trcAppSettings.loginConfig?.anonSettings || {}; }
  get authTypes() { return window.trcAppSettings.loginConfig?.authTypes || ["email"]; }
  get sessionTypes() { return window.trcAppSettings.loginConfig?.sessionTypes || ["individual"]; }
  get config() { return window.trcAppSettings.loginConfig; }
  get anonSession() { return window.trcAppSettings.loginConfig.anonSession; }

  // Render here instead of in the main app so it doesn't cause the entire page to rerender when the current view is changed
  get Component() {
    const { View, viewData } = this;
    const { Title } = Components;
    return () => (
      <React.Fragment>
        <Title title={View?.title} />
        <View app={this} {...(viewData || {})} />
      </React.Fragment>
    );
  }

  get showLoading() {
    return !this.ready;
  }

  get View() {
    return Components[this.currentView];
  }

  constructor() {
    makeObservable(this, {
      ready: observable,
      identity: observable,
      enterprise: observable,
      showLoading: computed,
      View: computed,
      currentView: observable,
      nextView: observable,
      viewData: observable,
      complete: observable,
      context: observable,
      team: observable
    });

    reaction(() => this.context, () => {
      window.trcAppSettings.loginConfig.context = this.context;
    })
    
    reaction(() => this.team, () => {
      window.trcAppSettings.loginConfig.team = this.team;
    })
  }

  async start() {
    window.loginStore = this;
    window.onLoginBundleReady?.();
  }
}